import {
  ActionFilterClass,
  ActionOption,
  Driver,
  MovementOption,
  SoundOption,
} from './../nav-processing/mappings/mappings.model';
import { MovementSource } from '../nav-processing/mappings/mappings.model';
import {
  ItemID,
  NavSettingsBundle,
  Access,
  SelectorType,
  CursorType,
  SwitchDescriptor,
  OptionItem,
  SettingsBlock,
  KeyboardLayouts,
} from './manual-settings.model';
import { Profile, ProfileStatus } from '../profile/profile.model';
import { MinimaxSpeechEmotions, VoicePreference, VoiceServiceSettings } from '../voice/voice.model';

export const availableMovementsV2: OptionItem[] = [
  {
    label: 'Boca: abrir e fechar',
    value: {
      name: 'Boca: abrir e fechar',
      function: 'findMouthOpen',
      source: MovementSource.face,
    },
  },
  {
    label: 'Boca: Sorriso',
    value: {
      name: 'Boca: Sorriso',
      function: 'findSmile',
      source: MovementSource.face,
    },
  },
  {
    label: 'Boca: beijo',
    value: {
      name: 'Boca: beijo',
      function: 'findMouthPuck',
      source: MovementSource.face,
    },
  },
  {
    label: 'Boca: beijo para a esquerda',
    value: {
      name: 'Boca: beijo para a esquerda',
      function: 'findMouthPuckLeft',
      source: MovementSource.face,
    },
  },
  {
    label: 'Boca: beijo para a direita',
    value: {
      name: 'Boca: beijo para a direita',
      function: 'findMouthPuckRight',
      source: MovementSource.face,
    },
  },
  {
    label: 'Olhar para a direita',
    value: {
      name: 'Olhar para a direita',
      function: 'findGazeRight',
      source: MovementSource.face,
    },
  },
  {
    label: 'Olhar para a esquerda',
    value: {
      name: 'Olhar para a esquerda',
      function: 'findGazeLeft',
      source: MovementSource.face,
    },
  },
  {
    label: 'Olhar para cima',
    value: {
      name: 'Olhar para cima',
      function: 'findGazeUp',
      source: MovementSource.face,
    },
  },
  {
    label: 'Piscar olho: esquerdo',
    value: {
      name: 'Piscar olho: apenas esquerdo',
      function: 'findLeftEyeBlink',
      source: MovementSource.face,
    },
  },
  {
    label: 'Piscar olho: direito',
    value: {
      name: 'Piscar olho: apenas direito',
      function: 'findRightEyeBlink',
      source: MovementSource.face,
    },
  },
  {
    label: 'Piscar olho: apenas esquerdo',
    value: {
      name: 'Piscar olho: apenas esquerdo',
      function: 'findLeftOnlyEyeBlink',
      source: MovementSource.face,
    },
  },
  {
    label: 'Piscar olho: apenas direito',
    value: {
      name: 'Piscar olho: apenas direito',
      function: 'findRightOnlyEyeBlink',
      source: MovementSource.face,
    },
  },
  {
    label: 'Piscar olho: ambos',
    value: {
      name: 'Piscar olho: ambos',
      function: 'findLeftAndRightEyeBlink',
      source: MovementSource.face,
    },
  },
  {
    label: 'Piscar olho: direito ou esquerdo',
    value: {
      name: 'Piscar olho: direito ou esquerdo',
      function: 'findLeftOrRightEyeBlink',
      source: MovementSource.face,
    },
  },
  {
    label: 'Levantar Sobrancelha',
    value: {
      name: 'Levantar Sobrancelha',
      function: 'findEyeBrowUp',
      source: MovementSource.face,
    },
  },
  {
    label: 'Abaixar Sobrancelha',
    value: {
      name: 'Abaixar Sobrancelha',
      function: 'findEyeBrowDown',
      source: MovementSource.face,
    },
  },
  // {name: 'Direção do olhar vertical', function: findGazeVertical, source: MovementSource.face},
  // {name: 'Direção do olhar horizontal', function: findGazeHorizontal, source: MovementSource.face},
  // {name: 'Direção do olhar vertical', function: this.findGazeVertical, source: MovementSource.face},
];

// TODO: VER SE PODE DELETAR ESSA PARTE
export const availableActions: ActionOption[] = [
  {
    name: 'Selecionar',
    function: 'actionSelect',
    filterClass: ActionFilterClass.scan,
  },
  {
    name: 'Cancelar Seleção',
    function: 'actionCancel',
    filterClass: ActionFilterClass.scan,
  },
  {
    name: 'Apagar',
    function: 'actionErase',
    filterClass: ActionFilterClass.scan,
  },
  // {
  //   name: 'Pausar',
  //   function: 'actionPause',
  //   filterClass: ActionFilterClass.scan,
  // },
  {
    name: 'Desfazer ou voltar',
    function: 'actionUndo',
    filterClass: ActionFilterClass.scan,
  },
  {
    name: 'Continuar',
    function: 'actionResume',
    filterClass: ActionFilterClass.scan,
  },
  {
    name: 'Cursor Horizontal',
    function: 'actionCursorH',
    filterClass: ActionFilterClass.cursorPosition,
  },
  {
    name: 'Cursor Vertical',
    function: 'actionCursorV',
    filterClass: ActionFilterClass.cursorPosition,
  },
  {
    name: 'Cursor Multi-direcional',
    function: 'actionCursorHV',
    filterClass: ActionFilterClass.cursorPosition,
  },
  {
    name: 'Suspender / Ativar',
    function: 'toggleMovementCapture',
    filterClass: ActionFilterClass.control,
  },
  {
    name: 'Falar',
    function: 'actionVocalize',
    filterClass: ActionFilterClass.control,
  },
];

// OBS: Para criar uma nova ação primeiro registra no availableActionsV2
export const availableActionsV2: OptionItem[] = [
  {
    label: 'Apagar',
    value: {
      name: 'Apagar',
      function: 'actionErase',
      filterClass: ActionFilterClass.control,
    },
  },
  {
    label: 'Cancelar Seleção',
    value: {
      name: 'Cancelar Seleção',
      function: 'actionCancel',
      filterClass: ActionFilterClass.scan,
    },
  },
  // TODO: Desenvolver essa funcionalidade 
  // {
  //   label: 'Desfazer ou voltar',
  //   value: {
  //     filterClass: ActionFilterClass.scan,
  //     function: 'actionUndo',
  //   },
  // },
  {
    label: 'Selecionar',
    value: {
      name: 'Selecionar',
      function: 'actionSelect',
      filterClass: ActionFilterClass.scan,
    },
  },
  {
    label: 'Suspender / Ativar',
    value: {
      name: 'Suspender / Ativar',
      function: 'toggleMovementCapture',
      filterClass: ActionFilterClass.control,
    },
  },
  {
    label: 'Falar',
    value: {
      name: 'Falar',
      function: 'actionVocalize',
      filterClass: ActionFilterClass.control,
    },
  },
  {
    label: 'Repetir o ultimo comando',
    value: {
      name: 'Repetir o ultimo comando',
      function: 'actionRepeat',
      filterClass: ActionFilterClass.control,
    },
  },
];

// OBS: Para criar uma nova ação primeiro registra no availableActionsV2
export const availableActionsAuto: OptionItem[] = [
  {
    label: 'Apagar',
    value: {
      name: 'Apagar',
      function: 'actionErase',
      filterClass: ActionFilterClass.control,
    },
  },
  {
    label: 'Cancelar Seleção',
    value: {
      name: 'Cancelar Seleção',
      function: 'actionCancelAuto',
      filterClass: ActionFilterClass.scan,
    },
  },
  // TODO: Desenvolver essa funcionalidade 
  // {
  //   label: 'Desfazer ou voltar',
  //   value: {
  //     filterClass: ActionFilterClass.scan,
  //     function: 'actionUndo',
  //   },
  // },
  {
    label: 'Selecionar',
    value: {
      name: 'Selecionar',
      function: 'actionSelect',
      filterClass: ActionFilterClass.scan,
    },
  },
  {
    label: 'Suspender / Ativar',
    value: {
      name: 'Suspender / Ativar',
      function: 'toggleMovementCapture',
      filterClass: ActionFilterClass.control,
    },
  },
  {
    label: 'Falar',
    value: {
      name: 'Falar',
      function: 'actionVocalize',
      filterClass: ActionFilterClass.control,
    },
  },
  {
    label: 'Repetir o ultimo comando',
    value: {
      name: 'Repetir o ultimo comando',
      function: 'actionRepeat',
      filterClass: ActionFilterClass.control,
    },
  },
];

export const selectorValues = {
  resolution: [
    { label: '1 Nível / Acionador', value: 1 },
    { label: '2 Níveis', value: 2 },
    { label: '3 Níveis', value: 3 },
    { label: '4 Níveis', value: 4 },
    { label: '6 Níveis', value: 6 },
    { label: '8 Níveis', value: 8 },
  ],
  resolutionPosition: [
    { label: '2 Níveis', value: 2 },
    { label: '3 Níveis', value: 3 },
    { label: '4 Níveis', value: 4 },
    { label: '6 Níveis', value: 6 },
    { label: '8 Níveis', value: 8 },
  ],
  hysteresis: [
    { label: 'Desligado', value: 0 },
    { label: 'Fraco', value: 0.05 },
    { label: 'Médio', value: 0.1 },
    { label: 'Forte', value: 0.3 },
  ],
  holdTime: [
    { label: 'Desligado', value: 0 },
    { label: 'Curto 100ms', value: 100 },
    { label: 'Médio 500ms', value: 500 },
    { label: 'Longo 1 segundo', value: 1000 },
  ],
};

export const availableKeyboardLayouts: OptionItem[] = [
  { label: 'Ordem alfabética', value: KeyboardLayouts.AlphabeticalOrder },
  { label: 'Otimizado Varredura', value: KeyboardLayouts.ScanOptmized },
  { label: 'Reduzido', value: KeyboardLayouts.Reduced }
];


export const availableSounds: OptionItem[] = [
  { label: 'Nenhum', value: { name: 'Nenhum', function: null, filterClass: ActionFilterClass.sound } },
  { label: 'Detector', value: { name: 'Detector', function: 'detector', filterClass: ActionFilterClass.sound } },
  { label: 'Bambu', value: { name: 'Bambu', function: 'knock', filterClass: ActionFilterClass.sound } },
  { label: 'Tulum', value: { name: 'Tulum', function: 'tulum', filterClass: ActionFilterClass.sound } },
  { label: 'Whoosh', value: { name: 'Whoosh', function: 'whoosh', filterClass: ActionFilterClass.sound } },
  { label: 'Pling', value: { name: 'Pling', function: 'pling', filterClass: ActionFilterClass.sound } },
  { label: 'Sci-Fi', value: { name: 'Sci-Fi', function: 'scifi', filterClass: ActionFilterClass.sound } },
  { label: 'Click', value: { name: 'Click', function: 'click', filterClass: ActionFilterClass.sound } },
  { label: 'Rolha', value: { name: 'Rolha', function: 'cork', filterClass: ActionFilterClass.sound } },
  { label: 'Processando', value: { name: 'Processando', function: 'processing', filterClass: ActionFilterClass.sound } },
  { label: 'Correto', value: { name: 'Correto', function: 'correct', filterClass: ActionFilterClass.sound } },
  { label: 'Errado', value: { name: 'Errado', function: 'wrong', filterClass: ActionFilterClass.sound } },
];


/////////////////////////////////////////////////
// Switches presets
/////////////////////////////////////////////////
const eyeSwitchTemplate: Partial<SwitchDescriptor> = {
  mappings: [{
    enabled: true,
    movement: {
      name: undefined,
      function: undefined,
      source: undefined,
    },
    detectionThreshold: 0.4,
    hysteresis: 0.05,
    resolution: 1,
    holdTime: 100,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
  options: [
    {
      settings: [
        {
          id: ItemID.OptEnabled,
          name: 'Ligar',
          settingKey: 'enabled',
          selectorType: SelectorType.Switch,
          default: true,
        },
        {
          id: ItemID.OptRange,
          name: 'Limiar de ativação',
          settingKey: 'detectionThreshold',
          selectorType: SelectorType.Range,
          extremes: { lower: 0, upper: 1 },
          default: 0.4,
        },
        {
          id: ItemID.OptAction,
          name: 'Ação',
          settingKey: 'detectionAction',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableActionsV2,
          default: availableActionsV2[0].value,
        },
        {
          id: ItemID.OptHysteresis,
          name: 'Movimentos involuntários',
          settingKey: 'hysteresis',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: selectorValues.hysteresis,
          default: selectorValues.hysteresis[0].value,
        },
        {
          id: ItemID.OptDuration,
          name: 'Duração mínima',
          settingKey: 'holdTime',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: selectorValues.holdTime,
          default: selectorValues.holdTime[0].value,
        },
        {
          id: ItemID.OptSound,
          name: 'Efeito sonoro',
          settingKey: 'actionSound',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableSounds,
          default: availableSounds[0].value,
        },
        {
          id: ItemID.OptSoundVolume,
          name: 'Volume sonoro',
          settingKey: 'actionSoundVolume',
          selectorType: SelectorType.Slider,
          extremes: { lower: 0, upper: 1 },
          default: 1,
        },
      ],
    },
  ],
};

const mouthSwitchTemplate: Partial<SwitchDescriptor> = {
  mappings: [{
    enabled: true,
    movement: {
      name: undefined,
      function: undefined,
      source: undefined,
    },
    detectionThreshold: 0.4,
    hysteresis: 0.1,
    resolution: 1,
    holdTime: 0,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
  options: [
    {
      settings: [
        {
          id: ItemID.OptEnabled,
          name: 'Ligar',
          settingKey: 'enabled',
          selectorType: SelectorType.Switch,
          default: true,
        },
        {
          id: ItemID.OptRange,
          name: 'Limiar de ativação',
          settingKey: 'detectionThreshold',
          selectorType: SelectorType.Range,
          extremes: { lower: 0, upper: 1 },
          default: 0.4,
        },
        {
          id: ItemID.OptAction,
          name: 'Ação',
          settingKey: 'detectionAction',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableActionsV2,
          default: availableActionsV2[0].value,
        },
        {
          id: ItemID.OptHysteresis,
          name: 'Movimentos involuntários',
          settingKey: 'hysteresis',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: selectorValues.hysteresis,
          default: selectorValues.hysteresis[0].value,
        },
        {
          id: ItemID.OptDuration,
          name: 'Duração mínima',
          settingKey: 'holdTime',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: selectorValues.holdTime,
          default: selectorValues.holdTime[0].value,
        },
        {
          id: ItemID.OptSound,
          name: 'Efeito sonoro',
          settingKey: 'actionSound',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableSounds,
          default: availableSounds[0].value,
        },
        {
          id: ItemID.OptSoundVolume,
          name: 'Volume sonoro',
          settingKey: 'actionSoundVolume',
          selectorType: SelectorType.Slider,
          extremes: { lower: 0, upper: 1 },
          default: 1,
        },
      ],
    },
  ],
};

const headSwitchTemplate: Partial<SwitchDescriptor> = {
  mappings: [{
    enabled: true,
    movement: {
      name: undefined,
      function: undefined,
      source: undefined,
    },
    detectionThreshold: 0.7,
    hysteresis: 0.1,
    resolution: 1,
    holdTime: 0,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
  options: [
    {
      settings: [
        {
          id: ItemID.OptEnabled,
          name: 'Ligar',
          settingKey: 'enabled',
          selectorType: SelectorType.Switch,
          default: true,
        },
        {
          id: ItemID.OptRange,
          name: 'Limiar de ativação',
          settingKey: 'detectionThreshold',
          selectorType: SelectorType.Range,
          extremes: { lower: 0, upper: 1 },
          default: 0.7,
        },
        {
          id: ItemID.OptAction,
          name: 'Ação',
          settingKey: 'detectionAction',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableActionsV2,
          default: availableActionsV2[0].value,
        },
        {
          id: ItemID.OptHysteresis,
          name: 'Movimentos involuntários',
          settingKey: 'hysteresis',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: selectorValues.hysteresis,
          default: selectorValues.hysteresis[0].value,
        },
        {
          id: ItemID.OptDuration,
          name: 'Duração mínima',
          settingKey: 'holdTime',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: selectorValues.holdTime,
          default: selectorValues.holdTime[0].value,
        },
        {
          id: ItemID.OptSound,
          name: 'Efeito sonoro',
          settingKey: 'actionSound',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableSounds,
          default: availableSounds[0].value,
        },
        {
          id: ItemID.OptSoundVolume,
          name: 'Volume sonoro',
          settingKey: 'actionSoundVolume',
          selectorType: SelectorType.Slider,
          extremes: { lower: 0, upper: 1 },
          default: 1,
        },
      ],
    },
  ],
};


/////////////////////////////////////////////////
// Switches presets
/////////////////////////////////////////////////

const headPitchSwitch: SwitchDescriptor = Object.assign({}, headSwitchTemplate, {
  id: ItemID.SwitchHeadPitch,
  name: 'Cabeça para baixo',
  mappings: [Object.assign({}, headSwitchTemplate.mappings[0], {
    movement: {
      name: 'Cabeça para baixo',
      function: 'findPitch',
      source: MovementSource.face,
    },
  })],
});

const headPitchUpSwitch: SwitchDescriptor = Object.assign({}, headSwitchTemplate, {
  id: ItemID.SwitchHeadPitchUp,
  name: 'Cabeça para cima',
  mappings: [Object.assign({}, headSwitchTemplate.mappings[0], {
    movement: {
      name: 'Cabeça para cima',
      function: 'findPitchUp',
      source: MovementSource.face,
    },
  })],
});

const headRollSwitch: SwitchDescriptor = Object.assign({}, headSwitchTemplate, {
  id: ItemID.SwitchHeadRoll,
  name: 'Inclinação direita',
  mappings: [Object.assign({}, headSwitchTemplate.mappings[0], {
    movement: {
      name: 'Inclinação direita',
      function: 'findRoll',
      source: MovementSource.face,
    },
  })],
});

const headRollSwitchLeft: SwitchDescriptor = Object.assign({}, headSwitchTemplate, {
  id: ItemID.SwitchHeadRollLeft,
  name: 'Inclinação esquerda',
  mappings: [Object.assign({}, headSwitchTemplate.mappings[0], {
    movement: {
      name: 'Inclinação esquerda',
      function: 'findRollLeft',
      source: MovementSource.face,
    },
  })],
});

const headYawSwitch: SwitchDescriptor = Object.assign({}, headSwitchTemplate, {
  id: ItemID.SwitchHeadYaw,
  name: 'Rotação horizontal direita',
  mappings: [Object.assign({}, headSwitchTemplate.mappings[0], {
    movement: {
      name: 'Rotação direita',
      function: 'findYaw',
      source: MovementSource.face,
    },
  })],
});

const headYawSwitchLeft: SwitchDescriptor = Object.assign({}, headSwitchTemplate, {
  id: ItemID.SwitchHeadYawLeft,
  name: 'Rotação horizontal esquerda',
  mappings: [Object.assign({}, headSwitchTemplate.mappings[0], {
    movement: {
      name: 'Rotação esquerda',
      function: 'findYawLeft',
      source: MovementSource.face,
    },
  })],
});

const mouthOpenSwitch: SwitchDescriptor = Object.assign({}, mouthSwitchTemplate, {
  id: ItemID.SwitchOpenMouth,
  name: 'Abrir a boca',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Abrir a boca',
      function: 'findMouthOpen',
      source: MovementSource.face,
    },
    detectionThreshold: 0.4,
    hysteresis: 0.05,
    resolution: 1,
    holdTime: 0,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
});
const mouthOpenSwitchSelect: SwitchDescriptor = Object.assign({}, mouthSwitchTemplate, {
  id: ItemID.SwitchOpenMouth,
  name: 'Abrir a boca',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Abrir a boca',
      function: 'findMouthOpen',
      source: MovementSource.face,
    },
    detectionThreshold: 0.4,
    hysteresis: 0.05,
    resolution: 1,
    holdTime: 0,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    detectionAction: {
      name: 'Selecionar',
      function: 'actionSelect',
      filterClass: ActionFilterClass.scan,
    },
    actionSoundVolume: 1
  }],
});
const mouthSmileSwitch: SwitchDescriptor = Object.assign({}, mouthSwitchTemplate, {
  id: ItemID.SwitchMouthSmile,
  name: 'Sorriso',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Sorriso',
      function: 'findSmile',
      source: MovementSource.face,
    },
    detectionThreshold: 0.4,
    hysteresis: 0.05,
    resolution: 1,
    holdTime: 0,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
});
const mouthPuckSwitch: SwitchDescriptor = Object.assign({}, mouthSwitchTemplate, {
  id: ItemID.SwitchMouthPuck,
  name: 'Beijo',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Beijo',
      function: 'findMouthPuck',
      source: MovementSource.face,
    },
    detectionThreshold: 0.4,
    hysteresis: 0.05,
    resolution: 1,
    holdTime: 0,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
});
const eyeBlinkAnySwitch: SwitchDescriptor = Object.assign({}, eyeSwitchTemplate, {
  id: ItemID.SwitchEyeBlinkAny,
  name: 'Piscar algum olho',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Piscar algum olho',
      function: 'findLeftOrRightEyeBlink',
      source: MovementSource.face,
    },
    detectionThreshold: 0.4,
    hysteresis: 0.05,
    resolution: 1,
    holdTime: 100,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
});
const eyeBlinkAnySwitchSelect: SwitchDescriptor = Object.assign({}, eyeSwitchTemplate, {
  id: ItemID.SwitchEyeBlinkAny,
  name: 'Piscar algum olho',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Piscar algum olho',
      function: 'findLeftOrRightEyeBlink',
      source: MovementSource.face,
    },
    detectionAction: {
      name: 'Selecionar',
      function: 'actionSelect',
      filterClass: ActionFilterClass.scan,
    },
    detectionThreshold: 0.4,
    hysteresis: 0.05,
    resolution: 1,
    holdTime: 100,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
});
const eyeBlinkBothSwitch: SwitchDescriptor = Object.assign({}, eyeSwitchTemplate, {
  id: ItemID.SwitchEyeBlinkBoth,
  name: 'Piscar ambos os olhos',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Piscar ambos os olhos',
      function: 'findLeftAndRightEyeBlink',
      source: MovementSource.face,
    },
    detectionThreshold: 0.4,
    hysteresis: 0.05,
    resolution: 1,
    holdTime: 100,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
});
const eyeBlinkLeftSwitch: SwitchDescriptor = Object.assign({}, eyeSwitchTemplate, {
  id: ItemID.SwitchEyeBlinkLeft,
  name: 'Piscar olho esquerdo',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Piscar olho esquerdo',
      function: 'findLeftEyeBlink',
      source: MovementSource.face,
    },
    detectionThreshold: 0.4,
    hysteresis: 0.05,
    resolution: 1,
    holdTime: 0,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
});

const eyeBlinkLeftOnlySwitch: SwitchDescriptor = Object.assign({}, eyeSwitchTemplate, {
  id: ItemID.SwitchEyeBlinkLeftOnly,
  name: 'Piscar só olho esquerdo',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Piscar só olho esquerdo',
      function: 'findLeftOnlyEyeBlink',
      source: MovementSource.face,
    },
    detectionThreshold: 0.4,
    hysteresis: 0.05,
    resolution: 1,
    holdTime: 0,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
});
const eyeBlinkRightSwitch: SwitchDescriptor = Object.assign({}, eyeSwitchTemplate, {
  id: ItemID.SwitchEyeBlinkRight,
  name: 'Piscar olho direito',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Piscar olho direito',
      function: 'findRightEyeBlink',
      source: MovementSource.face,
    },
    detectionThreshold: 0.4,
    hysteresis: 0.05,
    resolution: 1,
    holdTime: 0,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
});
const eyeBlinkRightOnlySwitch: SwitchDescriptor = Object.assign({}, eyeSwitchTemplate, {
  id: ItemID.SwitchEyeBlinkRightOnly,
  name: 'Piscar só olho direito',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Piscar só olho direito',
      function: 'findRightOnlyEyeBlink',
      source: MovementSource.face,
    },
    detectionThreshold: 0.4,
    hysteresis: 0.05,
    resolution: 1,
    holdTime: 0,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
});
const eyeLookUpSwitch: SwitchDescriptor = Object.assign({}, eyeSwitchTemplate, {
  id: ItemID.SwitchEyeBlinkBoth,
  name: 'Olhar para cima',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Olhar para cima',
      function: 'findGazeUp',
      source: MovementSource.face,
    },
    detectionThreshold: 0.6,
    hysteresis: 0.05,
    resolution: 1,
    holdTime: 100,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
});
const eyeBrowUpSwitch: SwitchDescriptor = Object.assign({}, eyeSwitchTemplate, {
  id: ItemID.SwitchEyeBrowUp,
  name: 'Levantar Sobrancelha',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Levantar Sobrancelha',
      function: 'findEyeBrowUp',
      source: MovementSource.face,
    },
    detectionThreshold: 0.4,
    hysteresis: 0.05,
    resolution: 1,
    holdTime: 100,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
});

const eyeBrowDownSwitch: SwitchDescriptor = Object.assign({}, eyeSwitchTemplate, {
  id: ItemID.SwitchEyeBrowDown,
  name: 'Abaixar Sobrancelha',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Abaixar Sobrancelha',
      function: 'findEyeBrowDown',
      source: MovementSource.face,
    },
    detectionThreshold: 0.4,
    hysteresis: 0.05,
    resolution: 1,
    holdTime: 100,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
});

const switchDwell: SwitchDescriptor = {
  id: ItemID.SwitchDwell,
  name: 'Auto (Tempo Parado)',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Auto (Tempo Parado)',
      function: 'findDwellTime',
      source: MovementSource.face,
    },
    // detectionAction: {
    //   name: 'Selecionar',
    //   function: 'actionSelect',
    //   filterClass: ActionFilterClass.scan,
    // },
    detectionThreshold: 1.5,
    hysteresis: 0,
    resolution: 1,
    holdTime: 0,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  },
  {
    enabled: true,
    movement: {
      name: 'Abrir a boca',
      function: 'findMouthOpen',
      source: MovementSource.face,
    },
    detectionThreshold: 0.5,
    hysteresis: 0.1,
    resolution: 1,
    holdTime: 0,
    detectionAction: {
      name: 'Suspender / Ativar',
      function: 'toggleMovementCapture',
      filterClass: ActionFilterClass.control,
    },
    actionSound: {
      name: 'Detector',
      function: 'detector',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
  options: [
    {
      name: 'Auto (Tempo Parado)',
      settings: [
        {
          id: ItemID.OptEnabled,
          name: 'Ligar',
          settingKey: 'enabled',
          selectorType: SelectorType.Switch,
          default: true,
        },
        {
          id: ItemID.OptRange,
          name: 'Tempo Mínimo',
          settingKey: 'detectionThreshold',
          selectorType: SelectorType.Range,
          extremes: { lower: 0, upper: 3 },
          default: 1.5,
        },
        {
          id: ItemID.OptAction,
          name: 'Ação',
          settingKey: 'detectionAction',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableActionsAuto,
          default: availableActionsAuto[0].value,
        },
        {
          id: ItemID.OptSound,
          name: 'Efeito sonoro',
          settingKey: 'actionSound',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableSounds,
          //default: availableSounds[0].value,
        },
        {
          id: ItemID.OptSoundVolume,
          name: 'Volume sonoro',
          settingKey: 'actionSoundVolume',
          selectorType: SelectorType.Slider,
          extremes: { lower: 0, upper: 1 },
          default: 1,
        },
      ],
    },
    {
      name: 'Gesto para Suspender / Ativar',
      settings: [
        {
          id: ItemID.OptRange,
          name: 'Tempo Mínimo',
          settingKey: 'detectionThreshold',
          selectorType: SelectorType.Range,
          extremes: { lower: 0, upper: 1 },
          default: 0.4,
        },
        {
          id: ItemID.OptMovement,
          name: 'Movimento',
          settingKey: 'movement',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableMovementsV2,
          default: availableMovementsV2[0].value,
        },
        {
          id: ItemID.OptHysteresis,
          name: 'Movimentos involuntários',
          settingKey: 'hysteresis',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: selectorValues.hysteresis,
          default: selectorValues.hysteresis[0].value,
        },
        {
          id: ItemID.OptDuration,
          name: 'Duração mínima',
          settingKey: 'holdTime',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: selectorValues.holdTime,
          default: selectorValues.holdTime[0].value,
        },
        {
          id: ItemID.OptSound,
          name: 'Efeito sonoro',
          settingKey: 'actionSound',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableSounds,
          default: availableSounds[0].value,
        },
        {
          id: ItemID.OptSoundVolume,
          name: 'Volume sonoro',
          settingKey: 'actionSoundVolume',
          selectorType: SelectorType.Slider,
          extremes: { lower: 0, upper: 1 },
          default: 1,
        },
      ],
    },
    // TESTANDO 
    // {
    //   name: 'Falar',
    //   settings: [
    //     {
    //       id: ItemID.OptRange,
    //       name: 'Limiar de ativação',
    //       settingKey: 'detectionThreshold',
    //       selectorType: SelectorType.Range,
    //       extremes: { lower: 0, upper: 1 },
    //       default: 0.4,
    //     },
    //     {
    //       id: ItemID.OptMovement,
    //       name: 'Movimento',
    //       settingKey: 'movement',
    //       selectorType: SelectorType.Dropdown,
    //       selectorOptionList: availableMovementsV2,
    //       default: availableMovementsV2[0].value,
    //     },
    //     {
    //       id: ItemID.OptHysteresis,
    //       name: 'Movimentos involuntários',
    //       settingKey: 'hysteresis',
    //       selectorType: SelectorType.Dropdown,
    //       selectorOptionList: selectorValues.hysteresis,
    //       default: selectorValues.hysteresis[0].value,
    //     },
    //     {
    //       id: ItemID.OptDuration,
    //       name: 'Duração mínima',
    //       settingKey: 'holdTime',
    //       selectorType: SelectorType.Dropdown,
    //       selectorOptionList: selectorValues.holdTime,
    //       default: selectorValues.holdTime[0].value,
    //     },
    //     {
    //       id: ItemID.OptSound,
    //       name: 'Efeito sonoro',
    //       settingKey: 'actionSound',
    //       selectorType: SelectorType.Dropdown,
    //       selectorOptionList: availableSounds,
    //       default: availableSounds[0].value,
    //     },
    //     {
    //       id: ItemID.OptSoundVolume,
    //       name: 'Volume sonoro',
    //       settingKey: 'actionSoundVolume',
    //       selectorType: SelectorType.Slider,
    //       extremes: { lower: 0, upper: 1 },
    //       default: 1,
    //     },
    //   ],
    // }
  ],
};

const switchDwellNavCursor: SwitchDescriptor = {
  id: ItemID.SwitchDwell,
  name: 'Auto (Tempo Parado)',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Auto (Tempo Parado)',
      function: 'findDwellTime',
      source: MovementSource.eyeTracker,
    },
    detectionAction: {
      name: 'Selecionar',
      function: 'actionSelect',
      filterClass: ActionFilterClass.scan,
    },
    detectionThreshold: 1.5,
    hysteresis: 0,
    resolution: 1,
    holdTime: 0,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  },
  {
    enabled: true,
    movement: {
      name: 'Abrir a boca',
      function: 'findMouthOpen',
      source: MovementSource.face,
    },
    detectionThreshold: 0.5,
    hysteresis: 0.1,
    resolution: 1,
    holdTime: 0,
    detectionAction: {
      name: 'Suspender / Ativar',
      function: 'toggleMovementCapture',
      filterClass: ActionFilterClass.control,
    },
    actionSound: {
      name: 'Detector',
      function: 'detector',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
  options: [
    {
      name: 'Auto (Tempo Parado)',
      settings: [
        {
          id: ItemID.OptEnabled,
          name: 'Ligar',
          settingKey: 'enabled',
          selectorType: SelectorType.Switch,
          default: true,
        },
        {
          id: ItemID.OptRange,
          name: 'Tempo Mínimo',
          settingKey: 'detectionThreshold',
          selectorType: SelectorType.Range,
          extremes: { lower: 0, upper: 3 },
          default: 1.5,
        },
        {
          id: ItemID.OptAction,
          name: 'Ação',
          settingKey: 'detectionAction',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableActionsV2,
          default: availableActionsV2[0].value,
        },
        {
          id: ItemID.OptSound,
          name: 'Efeito sonoro',
          settingKey: 'actionSound',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableSounds,
          default: availableSounds[0].value,
        },
        {
          id: ItemID.OptSoundVolume,
          name: 'Volume sonoro',
          settingKey: 'actionSoundVolume',
          selectorType: SelectorType.Slider,
          extremes: { lower: 0, upper: 1 },
          default: 1,
        },
      ],
    },
    {
      name: 'Gesto para Suspender / Ativar',
      settings: [
        {
          id: ItemID.OptRange,
          name: 'Tempo Mínimo',
          settingKey: 'detectionThreshold',
          selectorType: SelectorType.Range,
          extremes: { lower: 0, upper: 1 },
          default: 0.4,
        },
        {
          id: ItemID.OptMovement,
          name: 'Movimento',
          settingKey: 'movement',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableMovementsV2,
          default: availableMovementsV2[0].value,
        },
        {
          id: ItemID.OptHysteresis,
          name: 'Movimentos involuntários',
          settingKey: 'hysteresis',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: selectorValues.hysteresis,
          default: selectorValues.hysteresis[0].value,
        },
        {
          id: ItemID.OptDuration,
          name: 'Duração mínima',
          settingKey: 'holdTime',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: selectorValues.holdTime,
          default: selectorValues.holdTime[0].value,
        },
        {
          id: ItemID.OptSound,
          name: 'Efeito sonoro',
          settingKey: 'actionSound',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableSounds,
          default: availableSounds[0].value,
        },
        {
          id: ItemID.OptSoundVolume,
          name: 'Volume sonoro',
          settingKey: 'actionSoundVolume',
          selectorType: SelectorType.Slider,
          extremes: { lower: 0, upper: 1 },
          default: 1,
        },
      ],
    },
  ],
};

const switchMouseClickLeft: SwitchDescriptor = {
  id: ItemID.SwitchMouseClickLeft,
  name: 'Acionador de tela ou externo',
  mappings: [{
    enabled: true,
    movement: {
      name: 'Acionador de tela ou externo',
      function: 'findMouseClickLeft',
      source: MovementSource.mouse,
      driver: [Driver.mouse],
    },
    detectionThreshold: 0.5,
    resolution: 1,
    actionSound: {
      name: 'Click',
      function: 'click',
      filterClass: ActionFilterClass.sound,
    },
    actionSoundVolume: 1
  }],
  options: [
    {
      settings: [
        {
          id: ItemID.OptEnabled,
          name: 'Ligar',
          settingKey: 'enabled',
          selectorType: SelectorType.Switch,
          default: true,
        },
        // {
        //   id: ItemID.OptRange,
        //   name: 'Limiar de ativação',
        //   settingKey: 'detectionThreshold',
        //   selectorType: SelectorType.Range,
        //   extremes: { lower: 0, upper: 1 },
        //   default: 0.5,
        // },
        {
          id: ItemID.OptAction,
          name: 'Ação',
          settingKey: 'detectionAction',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableActionsV2,
          default: availableActionsV2[0].value,
        },
        // {
        //   id: ItemID.OptHysteresis,
        //   name: 'Movimentos involuntários',
        //   settingKey: 'hysteresis',
        //   selectorType: SelectorType.Dropdown,
        //   selectorOptionList: selectorValues.hysteresis,
        //   default: selectorValues.hysteresis[0].value,
        // },
        {
          id: ItemID.OptDuration,
          name: 'Duração mínima',
          settingKey: 'holdTime',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: selectorValues.holdTime,
          default: selectorValues.holdTime[0].value,
        },
        {
          id: ItemID.OptSound,
          name: 'Efeito sonoro',
          settingKey: 'actionSound',
          selectorType: SelectorType.Dropdown,
          selectorOptionList: availableSounds,
          default: availableSounds[0].value,
        },
        {
          id: ItemID.OptSoundVolume,
          name: 'Volume sonoro',
          settingKey: 'actionSoundVolume',
          selectorType: SelectorType.Slider,
          extremes: { lower: 0, upper: 1 },
          default: 1,
        },
      ],
    },
  ],
};

export const switchPresets: SwitchDescriptor[] = [
  mouthOpenSwitch,
  mouthSmileSwitch,
  mouthPuckSwitch,
  eyeBlinkAnySwitch,
  eyeBlinkBothSwitch,
  eyeBlinkRightSwitch,
  eyeBlinkLeftSwitch,
  eyeBlinkRightOnlySwitch,
  eyeBlinkLeftOnlySwitch,
  eyeLookUpSwitch,
  eyeBrowUpSwitch,
  eyeBrowDownSwitch,
  switchDwell,
  switchMouseClickLeft
];

export const switchPresetsHead: SwitchDescriptor[] = [
  headPitchSwitch,
  headPitchUpSwitch,
  headRollSwitch,
  headRollSwitchLeft,
  headYawSwitch,
  headYawSwitchLeft,
];




/////////////////////////////////////////////////
// Nav Settings Bundles
/////////////////////////////////////////////////
const baseBundleVersion = 12; // Confirmar com o henrique

export const bundleHead2DHV: NavSettingsBundle = {
  name: 'Rotações da Cabeça',
  id: ItemID.NavBundleHead2DHV,
  version: baseBundleVersion + 2,
  cursorType: CursorType.Face2D,
  // bundleOptions: [
  //   {
  //     name: 'Prevenção de erros',
  //     settings: [
  //       {
  //         id: ItemID.OptNavGuardTime,
  //         name: 'Tempo de guarda',
  //         settingKey: 'navGuardTimeout',
  //         selectorType: SelectorType.Dropdown,
  //       },
  //       {
  //         id: ItemID.OptNavFilterTime,
  //         name: 'Tempo de filtro',
  //         settingKey: 'cursorFilterTimeout',
  //         selectorType: SelectorType.Dropdown,
  //       },
  //     ],
  //   },
  // ],
  bundleOptions: [
    {
      name: '',
      settings: [
        {
          id: ItemID.OptNavSelectRawFeedback,
          name: 'Visualização da ação de seleção',
          settingKey: 'selectRawFeedback',
          selectorType: SelectorType.Switch,
          default: false,
        },
      ],
    },
  ],
  bundleOptionsState: {
    navGuardTimeout: 300,
    cursorFilterTimeout: 300,
    selectRawFeedback: false,
  },
  directions: [
    {
      id: ItemID.DirHeadY,
      name: 'Ajuste Horizontal',
      access: Access.Required,
      mappings: [{
        enabled: true,
        movement: {
          name: 'Cabeça Horizontal',
          function: 'findYaw',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Direção Horizontal',
          function: 'actionCursorH',
          filterClass: ActionFilterClass.cursorPosition,
        },
        range: { lower: 0.25, upper: 0.75 },
        hysteresis: 0.05,
        resolution: 6,
      }],
      options: [
        {
          settings: [
            {
              id: ItemID.OptRange,
              name: 'Zona de sensibilidade',
              settingKey: 'range',
              selectorType: SelectorType.Range,
              default: { lower: 0.25, upper: 0.75 },
              extremes: { lower: 0, upper: 1 },
            },
            {
              id: ItemID.OptHysteresis,
              name: 'Movimentos Involuntários',
              settingKey: 'hysteresis',
              selectorType: SelectorType.Dropdown,
              selectorOptionList: selectorValues.hysteresis,
              default: selectorValues.hysteresis[0].value,
            },
          ],
        },
      ],
    },
    {
      id: ItemID.DirHeadP,
      name: 'Ajuste Vertical',
      access: Access.Required,

      mappings: [{
        enabled: true,
        movement: {
          name: 'Cabeça Vertical',
          function: 'findPitch',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Direção Vertical',
          function: 'actionCursorV',
          filterClass: ActionFilterClass.cursorPosition,
        },
        range: { lower: 0.2, upper: 0.8 },
        hysteresis: 0.05,
        resolution: 6,
      }],
      options: [
        {
          settings: [
            {
              id: ItemID.OptRange,
              name: 'Zona de sensibilidade',
              settingKey: 'range',
              selectorType: SelectorType.Range,
              extremes: { lower: 0, upper: 1 },
              default: { lower: 0.25, upper: 0.75 },
            },
            {
              id: ItemID.OptHysteresis,
              name: 'Movimentos Involuntários',
              settingKey: 'hysteresis',
              selectorType: SelectorType.Dropdown,
              selectorOptionList: selectorValues.hysteresis,
              default: selectorValues.hysteresis[0].value,
            },
          ],
        },
      ],
    },
  ],
  switches: [
    mouthOpenSwitchSelect
  ],
  availableSwitches: switchPresets // Exclui os head switches
};

export const bundleEyeTrackerColibri: NavSettingsBundle = {
  name: 'Rastreador Ocular Peye',
  id: ItemID.NavBundleEyeTrackerPeye,
  version: baseBundleVersion + 3,
  cursorType: CursorType.EyeTracker,
  bundleOptions: [
    {
      name: '',
      settings: [
        {
          id: ItemID.OptSpeakPositioningTips,
          name: 'Dicas de posicionamento faladas',
          settingKey: 'speakPositioningTips',
          selectorType: SelectorType.Switch,
        },
        {
          id: ItemID.OptNavSelectRawFeedback,
          name: 'Visualização da ação de seleção',
          settingKey: 'selectRawFeedback',
          selectorType: SelectorType.Switch,
          default: false,
        },
        {
          id: ItemID.OptGazePointVisualization,
          name: 'Mostrar ponto de olhar',
          settingKey: 'gazePointVisualization',
          selectorType: SelectorType.Switch,
          default: true,
        },
      ],
    },
  ],
  bundleOptionsState: {
    navGuardTimeout: 300,
    cursorFilterTimeout: 300,
    speakPositioningTips: true,
    selectRawFeedback: false,
    gazePointVisualization: true,
  },
  directions: [
    {
      id: ItemID.DirPeyeEyeTrackerH,
      name: 'Ajuste Horizontal',
      access: Access.Required,
      mappings: [{
        enabled: true,
        movement: {
          name: 'Direção do Olhar Horizontal',
          function: 'findGazeH',
          source: MovementSource.eyeTracker,
          driver: [Driver.peyeTracker, Driver.face],
        },
        detectionAction: {
          name: 'Direção Horizontal',
          function: 'actionCursorH',
          filterClass: ActionFilterClass.cursorPosition,
        },
        range: { lower: 0, upper: 1 },
        hysteresis: 0,
        resolution: 0,
      }],
      options: [
        {
          settings: [
            {
              id: ItemID.OptRange,
              name: 'Zona de sensibilidade',
              settingKey: 'range',
              selectorType: SelectorType.Range,
              default: { lower: 0, upper: 1 },
              extremes: { lower: -0.1, upper: 1.1 },
            },
            {
              id: ItemID.OptHysteresis,
              name: 'Filtro de oscilações',
              settingKey: 'hysteresis',
              selectorType: SelectorType.Dropdown,
              selectorOptionList: selectorValues.hysteresis,
              default: selectorValues.hysteresis[0].value,
            },
          ],
        },
      ],
    },
    {
      id: ItemID.DirPeyeEyeTrackerV,
      name: 'Ajuste Vertical',
      access: Access.Required,

      mappings: [{
        enabled: true,
        movement: {
          name: 'Direção do Olhar Vertical',
          function: 'findGazeV',
          source: MovementSource.eyeTracker,
          driver: [Driver.peyeTracker, Driver.face],
        },
        detectionAction: {
          name: 'Direção Vertical',
          function: 'actionCursorV',
          filterClass: ActionFilterClass.cursorPosition,
        },
        range: { lower: 0, upper: 1 },
        hysteresis: 0,
        resolution: 0,
      }],
      options: [
        {
          settings: [
            {
              id: ItemID.OptRange,
              name: 'Zona de sensibilidade',
              settingKey: 'range',
              selectorType: SelectorType.Range,
              default: { lower: 0, upper: 1 },
              extremes: { lower: -0.1, upper: 1.1 },
            },
            {
              id: ItemID.OptHysteresis,
              name: 'Filtro de oscilações',
              settingKey: 'hysteresis',
              selectorType: SelectorType.Dropdown,
              selectorOptionList: selectorValues.hysteresis,
              default: selectorValues.hysteresis[0].value,
            },
          ],
        },
      ],
    },
  ],
  switches: [
    switchDwellNavCursor,
  ],
  availableSwitches: switchPresets.concat(
    headRollSwitch,
    headRollSwitchLeft,
  )
};

export const bundleRastreadorOcular: NavSettingsBundle = {
  name: 'Rastreador Ocular',
  id: ItemID.NavBundleRastreadorOcular,
  version: baseBundleVersion + 4,
  cursorType: CursorType.EyeTracker,
  bundleOptions: [
    {
      name: '',
      settings: [
        {
          id: ItemID.OptSpeakPositioningTips,
          name: 'Dicas de posicionamento faladas',
          settingKey: 'speakPositioningTips',
          selectorType: SelectorType.Switch,
        },
        {
          id: ItemID.OptNavSelectRawFeedback,
          name: 'Visualização da ação de seleção',
          settingKey: 'selectRawFeedback',
          selectorType: SelectorType.Switch,
          default: false,
        },
        {
          id: ItemID.OptRastreadorImage,
          name: 'Mostrar imagem do rastreador ocular',
          settingKey: 'rastreadorImage',
          selectorType: SelectorType.Switch,
          default: false,
        },
        {
          id: ItemID.OptRastreadorGlasses,
          name: 'Uso de óculos',
          settingKey: 'rastreadorGlasses',
          selectorType: SelectorType.Switch,
          default: false,
        },
        {
          id: ItemID.OptCalibrationButton,
          name: 'Calibrar rastreador',
          settingKey: 'calibrationButton',
          selectorType: SelectorType.Button,
        },
        {
          id: ItemID.OptGazePointVisualization,
          name: 'Mostrar ponto de olhar',
          settingKey: 'gazePointVisualization',
          selectorType: SelectorType.Switch,
          default: true,
        }
      ],
    },
  ],
  bundleOptionsState: {
    navGuardTimeout: 300,
    cursorFilterTimeout: 300,
    speakPositioningTips: false,
    selectRawFeedback: false,
    gazePointVisualization: true,
  },
  directions: [
    {
      id: ItemID.DirPeyeEyeTrackerH,
      name: 'Ajuste Horizontal',
      access: Access.Required,
      mappings: [{
        enabled: true,
        movement: {
          name: 'Direção do Olhar Horizontal',
          function: 'findGazeH',
          source: MovementSource.eyeTracker,
          driver: [Driver.rastreador],
        },
        detectionAction: {
          name: 'Direção Horizontal',
          function: 'actionCursorH',
          filterClass: ActionFilterClass.cursorPosition,
        },
        range: { lower: 0, upper: 1 },
        hysteresis: 0,
        resolution: 0,
      }],
      options: [
        {
          settings: [
            {
              id: ItemID.OptRange,
              name: 'Zona de sensibilidade',
              settingKey: 'range',
              selectorType: SelectorType.Range,
              default: { lower: 0, upper: 1 },
              extremes: { lower: -0.1, upper: 1.1 },
            },
            {
              id: ItemID.OptHysteresis,
              name: 'Filtro de oscilações',
              settingKey: 'hysteresis',
              selectorType: SelectorType.Dropdown,
              selectorOptionList: selectorValues.hysteresis,
              default: selectorValues.hysteresis[0].value,
            },
          ],
        },
      ],
    },
    {
      id: ItemID.DirPeyeEyeTrackerV,
      name: 'Ajuste Vertical',
      access: Access.Required,

      mappings: [{
        enabled: true,
        movement: {
          name: 'Direção do Olhar Vertical',
          function: 'findGazeV',
          source: MovementSource.eyeTracker,
          driver: [Driver.rastreador],
        },
        detectionAction: {
          name: 'Direção Vertical',
          function: 'actionCursorV',
          filterClass: ActionFilterClass.cursorPosition,
        },
        range: { lower: 0, upper: 1 },
        hysteresis: 0,
        resolution: 0,
      }],
      options: [
        {
          settings: [
            {
              id: ItemID.OptRange,
              name: 'Zona de sensibilidade',
              settingKey: 'range',
              selectorType: SelectorType.Range,
              default: { lower: 0, upper: 1 },
              extremes: { lower: -0.1, upper: 1.1 },
            },
            {
              id: ItemID.OptHysteresis,
              name: 'Filtro de oscilações',
              settingKey: 'hysteresis',
              selectorType: SelectorType.Dropdown,
              selectorOptionList: selectorValues.hysteresis,
              default: selectorValues.hysteresis[0].value,
            },
          ],
        },
      ],
    },
  ],
  switches: [
    eyeBlinkBothSwitch,
  ],
  availableSwitches: switchPresets
};

export const bundleTobii: NavSettingsBundle = {
  name: 'Rastreador Ocular Tobii',
  id: ItemID.NavBundleTobii,
  version: baseBundleVersion + 1,
  cursorType: CursorType.EyeTracker,
  bundleOptions: [
    {
      name: '',
      settings: [
        {
          id: ItemID.OptNavSelectRawFeedback,
          name: 'Visualização da ação de seleção',
          settingKey: 'selectRawFeedback',
          selectorType: SelectorType.Switch,
          default: false,
        },
        {
          id: ItemID.OptGazePointVisualization,
          name: 'Mostrar ponto de olhar',
          settingKey: 'gazePointVisualization',
          selectorType: SelectorType.Switch,
          default: true,
        },
      ],
    },
  ],
  bundleOptionsState: {
    navGuardTimeout: 300,
    cursorFilterTimeout: 300,
    selectRawFeedback: true,
    gazePointVisualization: true,
  },
  directions: [
    {
      id: ItemID.DirTobiiEyeTrackerH,
      name: 'Ajuste Horizontal',
      access: Access.Required,
      mappings: [{
        enabled: true,
        movement: {
          name: 'Direção do Olhar Horizontal',
          function: 'findGazeH',
          source: MovementSource.eyeTracker,
          driver: [Driver.eyeTracker],
        },
        detectionAction: {
          name: 'Direção Horizontal',
          function: 'actionCursorH',
          filterClass: ActionFilterClass.cursorPosition,
        },
        range: { lower: 0, upper: 1 },
        hysteresis: 0.,
        resolution: 0,
      }],
      options: [
        {
          settings: [
            {
              id: ItemID.OptRange,
              name: 'Zona de sensibilidade',
              settingKey: 'range',
              selectorType: SelectorType.Range,
              default: { lower: 0, upper: 1 },
              extremes: { lower: -0.1, upper: 1.1 },
            },
            {
              id: ItemID.OptHysteresis,
              name: 'Filtro de oscilações',
              settingKey: 'hysteresis',
              selectorType: SelectorType.Dropdown,
              selectorOptionList: selectorValues.hysteresis,
              default: selectorValues.hysteresis[0].value,
            },
          ],
        },
      ],
    },
    {
      id: ItemID.DirTobiiEyeTrackerV,
      name: 'Ajuste Vertical',
      access: Access.Required,

      mappings: [{
        enabled: true,
        movement: {
          name: 'Direção do Olhar Vertical',
          function: 'findGazeV',
          source: MovementSource.eyeTracker,
          driver: [Driver.eyeTracker],
        },
        detectionAction: {
          name: 'Direção Vertical',
          function: 'actionCursorV',
          filterClass: ActionFilterClass.cursorPosition,
        },
        range: { lower: 0, upper: 1 },
        hysteresis: 0,
        resolution: 0,
      }],
      options: [
        {
          settings: [
            {
              id: ItemID.OptRange,
              name: 'Zona de sensibilidade',
              settingKey: 'range',
              selectorType: SelectorType.Range,
              default: { lower: 0, upper: 1 },
              extremes: { lower: -0.1, upper: 1.1 },
            },
            {
              id: ItemID.OptHysteresis,
              name: 'Filtro de oscilações',
              settingKey: 'hysteresis',
              selectorType: SelectorType.Dropdown,
              selectorOptionList: selectorValues.hysteresis,
              default: selectorValues.hysteresis[0].value,
            },
          ],
        },
      ],
    },
  ],
  switches: [
    switchDwellNavCursor
  ],
  availableSwitches: switchPresets
};

export const bundleGazeTracker: NavSettingsBundle = {
  name: 'Direção do Olhar WebCam',
  id: ItemID.NavBundleGazeTracker,
  version: baseBundleVersion + 1,
  cursorType: CursorType.GazeTracker,
  bundleOptions: [
    {
      name: '',
      settings: [
        {
          id: ItemID.OptNavSelectRawFeedback,
          name: 'Visualização da ação de seleção',
          settingKey: 'selectRawFeedback',
          selectorType: SelectorType.Switch,
          default: false,
        },
        {
          id: ItemID.OptNavDwellDuration,
          name: 'Tempo de seleção (ms)',
          settingKey: 'dwellDuration',
          selectorType: SelectorType.SliderMS,
          // 300ms to 3000ms, step defined in template as 50ms
          extremes: { lower: 300, upper: 3000 },
          default: 1500,
        },
        {
          id: ItemID.OptGazeDebugUseMouse,
          name: 'Depurar: usar mouse como olhar',
          settingKey: 'gazeDebugUseMouse',
          selectorType: SelectorType.Switch,
          default: false,
        },
        {
          id: ItemID.OptGazePointVisualization,
          name: 'Mostrar ponto de olhar',
          settingKey: 'gazePointVisualization',
          selectorType: SelectorType.Switch,
          default: true,
        },
        {
          id: ItemID.OptGazeHideDwellBorder,
          name: 'Ocultar borda de seleção',
          settingKey: 'gazeHideDwellBorder',
          selectorType: SelectorType.Switch,
          // Default true so the outer dwell border is hidden by default
          default: true,
        },
      ],
    },
  ],
  bundleOptionsState: {
    navGuardTimeout: 300,
    cursorFilterTimeout: 300,
    selectRawFeedback: true,
    dwellDuration: 2500,
    gazeDebugUseMouse: false,
    gazePointVisualization: false,
    // Hide the outer dwell border by default
    gazeHideDwellBorder: true,
  },
  directions: [
    {
      id: ItemID.DirGazeH,
      name: 'Ajuste Horizontal',
      access: Access.Required,
      mappings: [{
        enabled: true,
        movement: {
          name: 'Direção do Olhar Horizontal',
          function: 'findGazeH',
          source: MovementSource.eyeTracker,
          driver: [Driver.gazeWeb],
        },
        range: { lower: 0, upper: 1 },
        hysteresis: 0,
        resolution: 0,
      }],
    },
    {
      id: ItemID.DirGazeV,
      name: 'Ajuste Vertical',
      access: Access.Required,
      mappings: [{
        enabled: true,
        movement: {
          name: 'Direção do Olhar Vertical',
          function: 'findGazeV',
          source: MovementSource.eyeTracker,
          driver: [Driver.gazeWeb],
        },
        range: { lower: 0, upper: 1 },
        hysteresis: 0,
        resolution: 0,
      }],
    },
  ],
  switches: [

  ],
  availableSwitches: []
};

export const bundleHead1DHMouth1DV: NavSettingsBundle = {
  name: 'Rotações da Cabeça',
  id: ItemID.NavBundleHead1DHMouth1DV,
  version: baseBundleVersion + 2,
  cursorType: CursorType.Face2D,
  bundleOptions: [
    {
      name: '',
      settings: [
        {
          id: ItemID.OptNavSelectRawFeedback,
          name: 'Visualização da ação de seleção',
          settingKey: 'selectRawFeedback',
          selectorType: SelectorType.Switch,
          default: false,
        },
      ],
    },
  ],
  bundleOptionsState: {
    navGuardTimeout: 300,
    cursorFilterTimeout: 300,
    selectRawFeedback: false,
  },
  directions: [
    {
      id: ItemID.DirHeadY,
      name: 'Ajuste Horizontal',
      access: Access.Required,
      mappings: [{
        enabled: true,
        movement: {
          name: 'Cabeça Horizontal',
          function: 'findYaw',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Direção Horizontal',
          function: 'actionCursorH',
          filterClass: ActionFilterClass.cursorPosition,
        },
        range: { lower: 0.25, upper: 0.75 },
        hysteresis: 0.05,
        resolution: 6,
      }],
      options: [
        {
          settings: [
            {
              id: ItemID.OptRange,
              name: 'Zona de sensibilidade',
              settingKey: 'range',
              selectorType: SelectorType.Range,
              default: { lower: 0.25, upper: 0.75 },
              extremes: { lower: 0, upper: 1 },
            },
            {
              id: ItemID.OptHysteresis,
              name: 'Movimentos Involuntários',
              settingKey: 'hysteresis',
              selectorType: SelectorType.Dropdown,
              selectorOptionList: selectorValues.hysteresis,
              default: selectorValues.hysteresis[0].value,
            },
          ],
        },
      ],
    },
    {
      id: ItemID.DirMouthOpen,
      name: 'Ajuste Vertical',
      access: Access.Required,

      mappings: [{
        enabled: true,
        movement: {
          name: 'Abrir a Boca',
          function: 'findMouthOpen',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Direção Vertical',
          function: 'actionCursorV',
          filterClass: ActionFilterClass.cursorPosition,
        },
        range: { lower: 0.25, upper: 0.75 },
        hysteresis: 0.05,
        resolution: 6,
      }],
      options: [
        {
          settings: [
            {
              id: ItemID.OptRange,
              name: 'Limiar de ativação',
              settingKey: 'detectionThreshold',
              selectorType: SelectorType.Range,
              extremes: { lower: 0, upper: 1 },
              default: 0.4,
            },
            {
              id: ItemID.OptHysteresis,
              name: 'Movimentos Involuntários',
              settingKey: 'hysteresis',
              selectorType: SelectorType.Dropdown,
              selectorOptionList: selectorValues.hysteresis,
              default: selectorValues.hysteresis[0].value,
            },
          ],
        },
      ],
    },
  ],
  switches: [
    eyeBlinkAnySwitchSelect
  ],
  availableSwitches: [
    eyeBlinkAnySwitch,
    eyeBlinkBothSwitch,
    eyeBlinkRightSwitch,
    eyeBlinkLeftSwitch,
    eyeBlinkRightOnlySwitch,
    eyeBlinkLeftOnlySwitch,
    eyeBrowUpSwitch,
    eyeBrowDownSwitch,
    headPitchSwitch,
    headPitchUpSwitch,
    headRollSwitch,
    headRollSwitchLeft,
    switchDwell
  ]
};

export const bundleHead1DH: NavSettingsBundle = {
  name: 'Rotação Horizontal da Cabeça',
  id: ItemID.NavBundleHead1DH,
  version: baseBundleVersion + 2,
  cursorType: CursorType.Face1D,
  bundleOptions: [
    {
      name: '',
      settings: [
        {
          id: ItemID.OptNavSelectRawFeedback,
          name: 'Visualização da ação de seleção',
          settingKey: 'selectRawFeedback',
          selectorType: SelectorType.Switch,
          default: false,
        },
      ],
    },
  ],
  bundleOptionsState: {
    navGuardTimeout: 300,
    cursorFilterTimeout: 300,
    selectRawFeedback: false,
  },
  directions: [
    {
      id: ItemID.DirHeadY,
      name: 'Ajuste Horizontal',
      access: Access.Required,
      mappings: [{
        enabled: true,
        movement: {
          name: 'Cabeça Horizontal',
          function: 'findYaw',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Direção Horizontal e Vertical',
          function: 'actionCursorHV',
          filterClass: ActionFilterClass.cursorPosition,
        },
        range: { lower: 0.25, upper: 0.75 },
        hysteresis: 0.05,
        resolution: 6,
      }],
      options: [
        {
          settings: [
            {
              id: ItemID.OptRange,
              name: 'Zona de sensibilidade',
              settingKey: 'range',
              selectorType: SelectorType.Range,
              default: { lower: 0.25, upper: 0.75 },
              extremes: { lower: 0, upper: 1 },
            },
            {
              id: ItemID.OptResolution,
              name: 'Níveis / Resolução',
              settingKey: 'resolution',
              selectorType: SelectorType.Dropdown,
              selectorOptionList: selectorValues.resolutionPosition,
              default: 6,
            },
            {
              id: ItemID.OptHysteresis,
              name: 'Movimentos Involuntários',
              settingKey: 'hysteresis',
              selectorType: SelectorType.Dropdown,
              selectorOptionList: selectorValues.hysteresis,
              default: selectorValues.hysteresis[0].value,
            },
          ],
        },
      ],
    }
  ],
  switches: [
    mouthOpenSwitchSelect
  ],
  availableSwitches: switchPresets.concat([
    headPitchSwitch,
    headPitchUpSwitch,
    headRollSwitch,
    headRollSwitchLeft,
  ]) // exclude head yaw
};

export const bundleMouth1D: NavSettingsBundle = {
  name: 'Abrir a Boca',
  id: ItemID.NavBundleMouth1D,
  version: baseBundleVersion + 3,
  cursorType: CursorType.Face1D,
  bundleOptions: [
    {
      name: '',
      settings: [
        {
          id: ItemID.OptNavSelectRawFeedback,
          name: 'Visualização da ação de seleção',
          settingKey: 'selectRawFeedback',
          selectorType: SelectorType.Switch,
          default: false,
        },
      ],
    },
  ],
  bundleOptionsState: {
    navGuardTimeout: 300,
    cursorFilterTimeout: 300,
    selectRawFeedback: false,
  },
  directions: [
    {
      id: ItemID.DirMouthOpen,
      name: 'Ajuste Bidirecional',
      access: Access.Required,

      mappings: [{
        enabled: true,
        movement: {
         
          name: 'Abrir a Boca',
          function: 'findMouthOpen',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Direção Vertical e Vertical',
          function: 'actionCursorHV',
          filterClass: ActionFilterClass.cursorPosition,
        },
        range: { lower: 0.25, upper: 0.75 },
        hysteresis: 0.05,
        resolution: 3,
      }],
      options: [
        {
          settings: [
            {
              id: ItemID.OptRange,
              name: 'Limiar de ativação',
              settingKey: 'range',
              selectorType: SelectorType.Range,
              extremes: { lower: 0, upper: 1 },
              default: { lower: 0.25, upper: 0.75 },
            },
            {
              id: ItemID.OptResolution,
              name: 'Níveis / Resolução',
              settingKey: 'resolution',
              selectorType: SelectorType.Dropdown,
              selectorOptionList: selectorValues.resolutionPosition,
              default: 3,
            },
            {
              id: ItemID.OptHysteresis,
              name: 'Movimentos Involuntários',
              settingKey: 'hysteresis',
              selectorType: SelectorType.Dropdown,
              selectorOptionList: selectorValues.hysteresis,
              default: selectorValues.hysteresis[0].value,
            },
          ],
        },
      ],
    },
  ],
  switches: [
    eyeBlinkAnySwitchSelect
  ],
  availableSwitches: [ // exclude all mouth switches
    eyeBlinkAnySwitch,
    eyeBlinkBothSwitch,
    eyeBlinkRightSwitch,
    eyeBlinkLeftSwitch,
    eyeBlinkRightOnlySwitch,
    eyeBlinkLeftOnlySwitch,
    eyeBrowUpSwitch,
    eyeBrowDownSwitch,
    switchDwell,
    ...switchPresetsHead
  ]
};

export const bundleScan: NavSettingsBundle = {
  name: 'Varredura automática',
  id: ItemID.NavBundleScan,
  version: baseBundleVersion + 3,
  cursorType: CursorType.Scan,
  bundleOptions: [
    {
      name: 'Varredura',
      settings: [
        {
          id: ItemID.OptNavGuardTime,
          name: 'Intervalo de avanço',
          settingKey: 'scanInterval',
          selectorType: SelectorType.SliderMS,
          extremes: { lower: 500, upper: 6000 },
          default: 1000,
        },
        {
          id: ItemID.OptNavScanAutoPauseLoops,
          name: 'Tempo para pausa automática',
          settingKey: 'scanAutoPauseInterval',
          selectorType: SelectorType.SliderMS,
          extremes: { lower: 5000, upper: 30000 },
          default: 12000,
        },
        {
          id: ItemID.OptNavSelectRawFeedback,
          name: 'Visualização da ação de seleção',
          settingKey: 'selectRawFeedback',
          selectorType: SelectorType.Switch,
          default: false,
        },

      ],
    },
    // {
    //   name: 'Prevenção de erros',
    //   settings: [
    //     {
    //       id: ItemID.OptNavGuardTime,
    //       name: 'Tempo de guarda',
    //       settingKey: 'navGuardTimeout',
    //       selectorType: SelectorType.Dropdown,
    //     },
    //     {
    //       id: ItemID.OptNavFilterTime,
    //       name: 'Tempo de filtro',
    //       settingKey: 'cursorFilterTimeout',
    //       selectorType: SelectorType.Dropdown,
    //     },
    //   ],
    // },
  ],
  bundleOptionsState: {
    navGuardTimeout: 300,
    cursorFilterTimeout: 300,
    scanInterval: 1000,
    selectRawFeedback: false,
    scanOptimizeKeyboard: true,
  },
  directions: [],
  switches: [
    mouthOpenSwitchSelect
  ],
  availableSwitches: switchPresets.concat(switchPresetsHead)
};

export const bundleTouch: NavSettingsBundle = {
  name: 'Toque na Tela',
  id: ItemID.NavBundleTouch,
  version: baseBundleVersion + 2,
  cursorType: CursorType.Touch,
  bundleOptions: [
    {
      name: 'Toque Assistivo',
      settings: [
        {
          id: ItemID.OptNavGuardTime,
          name: 'Duração mínima do toque',
          settingKey: 'touchFilterDuration',
          selectorType: SelectorType.SliderMS,
          extremes: { lower: 0, upper: 2000 },
          default: 0,
        },
        {
          id: ItemID.OptNavScanAutoPauseLoops,
          name: 'Tempo de repetição',
          settingKey: 'touchRepetitionFilterDuration',
          selectorType: SelectorType.SliderMS,
          extremes: { lower: 0, upper: 2000 },
          default: 0,
        },
        {
          id: ItemID.OptNavSelectRawFeedback,
          name: 'Visualização da ação de seleção',
          settingKey: 'selectRawFeedback',
          selectorType: SelectorType.Switch,
          default: false,
        },
      ],
    },
  ],
  bundleOptionsState: {
    navGuardTimeout: 300,
    cursorFilterTimeout: 300,
    scanInterval: 1000,
    selectRawFeedback: false,
  },
  directions: [],
  switches: [],
  availableSwitches: switchPresets.concat(switchPresetsHead)
};

export const availableNavigationPresets: Array<NavSettingsBundle> = [
  //presetEyeTracker,
  bundleHead2DHV,
  bundleHead1DHMouth1DV,
  bundleHead1DH,
  bundleMouth1D,
  bundleScan,
  bundleTouch
];

/////////////////////////////////////////////////
// Voice
/////////////////////////////////////////////////

export const defaultVoiceServiceSettings: VoiceServiceSettings = {
  availableVoices: [
    {
      name: 'Voz padrão do Sistema',
      engine: 'default',
      voiceURI: 'default',
      localService: true,
      lang: 'pt-BR',
      default: true,
    },
  ],
  primaryVoice: {
    name: 'Voz padrão do Sistema',
    voiceURI: 'default',
    engine: 'default',
    localService: true,
    lang: 'pt-BR',
    default: true,
  },
  volume: 100,
}

/////////////////////////////////////////////////
//Keyboard options
/////////////////////////////////////////////////
export const availableKeyboardPresets: Array<SettingsBlock> = [
  {
    name: 'Teclados',
    settings: [
      {
        name: 'Teclado ABCDE',
        settingKey: 'keyboardLayout',
        id: ItemID.OptGeneralKeyboardLayout,
        selectorType: SelectorType.Dropdown,
        selectorOptionList: availableKeyboardLayouts,
        default: availableKeyboardLayouts[0].value,
      }
    ]
  }
];

/////////////////////////////////////////////////
// Profile presets
/////////////////////////////////////////////////

export const profilePresets: Profile[] = [
  {
    name: 'Cabeça: Rotação Horizontal e Vertical',
    voiceServiceSettings: defaultVoiceServiceSettings,
    navSettingsBundle: bundleHead2DHV,
    status: ProfileStatus.Available,
    //generalSettings: [availableKeyboardPresets],
    generalSettingsState: {
      keyboardLayout: availableKeyboardLayouts[0].value,
    },
    version: 3,
  },
  {
    name: 'Cabeça Horizontal e Abrir Boca',
    voiceServiceSettings: defaultVoiceServiceSettings,
    navSettingsBundle: bundleHead1DHMouth1DV,
    status: ProfileStatus.Available,
    generalSettingsState: {
      keyboardLayout: availableKeyboardLayouts[0].value,
    },
    version: 3,
  },
  {
    name: 'Cabeça Horizontal',
    voiceServiceSettings: defaultVoiceServiceSettings,
    navSettingsBundle: bundleHead1DH,
    status: ProfileStatus.Available,
    generalSettingsState: {
      keyboardLayout: availableKeyboardLayouts[0].value,
    },
    version: 3,
  },
  // {
  //   name: 'Cabeça Vertical',
  //   voiceServiceSettings: defaultVoiceServiceSettings,
  //   navSettingsBundle: bundleHead1DV,
  //   status: ProfileStatus.Available,
  //   version: 1,
  // },
  {
    name: 'Abrir boca',
    voiceServiceSettings: defaultVoiceServiceSettings,
    navSettingsBundle: bundleMouth1D,
    status: ProfileStatus.Available,
    generalSettingsState: {
      keyboardLayout: availableKeyboardLayouts[0].value,
    },
    version: 3,
  },
  {
    name: 'Varredura Automática',
    voiceServiceSettings: defaultVoiceServiceSettings,
    navSettingsBundle: bundleScan,
    status: ProfileStatus.Available,
    generalSettingsState: {
      keyboardLayout: availableKeyboardLayouts[1].value,
    },
    version: 3,
  },
  // {
  //   name: 'Varredura Alfabética',
  //   voiceServiceSettings: defaultVoiceServiceSettings,
  //   navSettingsBundle: bundleScan,
  //   status: ProfileStatus.Available,
  //   generalSettingsState: {
  //     keyboardLayout: availableKeyboardLayouts[0].value,
  //   },
  //   version: 3,
  // },
  {
    name: 'Toque na Tela',
    voiceServiceSettings: defaultVoiceServiceSettings,
    navSettingsBundle: bundleTouch,
    status: ProfileStatus.Available,
    generalSettingsState: {
      keyboardLayout: availableKeyboardLayouts[0].value,
    },
    version: 3,
  },
  {
    name: 'Rastreador Ocular WebCam',
    voiceServiceSettings: defaultVoiceServiceSettings,
    navSettingsBundle: bundleGazeTracker,
    status: ProfileStatus.Available,
    version: 1,
  },
  // {
  //   name: 'Rastreador Ocular',
  //   voiceServiceSettings: defaultVoiceServiceSettings,
  //   navSettingsBundle: bundleRastreadorOcular,
  //   status: ProfileStatus.Available,
  //   generalSettingsState: {
  //     keyboardLayout: availableKeyboardLayouts[0].value,
  //   },
  //   version: 3,
  // },
  // {
  //   name: 'Livre',
  //   voiceServiceSettings: defaultVoiceServiceSettings,
  //   navSettingsBundle: presetBidirectionalHead,
  //   status: ProfileStatus.Available,
  //   version: 1,
  // },
];

export const profilePresetsExperimental: Profile[] = [

  {
    name: 'Rastreador Ocular Tobii',
    voiceServiceSettings: defaultVoiceServiceSettings,
    navSettingsBundle: bundleTobii,
    status: ProfileStatus.Available,
    version: 3,
  },
  {
    name: 'Rastreador Ocular Peye',
    voiceServiceSettings: defaultVoiceServiceSettings,
    navSettingsBundle: bundleEyeTrackerColibri,
    status: ProfileStatus.Available,
    version: 3,
  }
];


/////////////////////////////////////////////////
// Default Custom Voices
/////////////////////////////////////////////////

export const defaultCustomVoices: VoicePreference[] = [
  {
    engine: 'eleven',
    name: 'Charles - Adulta',
    voiceURI: 'IKne3meq5aSn9XLyUdCD',
  },
  {
    engine: 'eleven',
    name: 'Criança Neutra V1',
    voiceURI: 'yOiEJ3WNzY7Of19ISL2v',
  },
  {
    engine: 'eleven',
    name: 'Laura - Jovem',
    voiceURI: 'FGY2WhTYpPnrIDTdsKH5',
  },
  {
    engine: 'eleven',
    name: 'Lilian - Adulta',
    voiceURI: 'pFZP5JQG7iQjIQuC4Bku',
  },
  {
    engine: 'eleven',
    name: 'Liu - Adulta',
    voiceURI: 'TX3LPaxmHKxFdv7VOQHJ',
  },
  {
    engine: 'eleven',
    name: 'Rita - Adulta',
    voiceURI: 'SAz9YHcvj6GT2YYXdXww',
  },
  {
    engine: 'eleven',
    name: 'William - Adulta',
    voiceURI: 'bIHbv24MWmeRgasZH58o',
  },
  {
    engine: 'minimax',
    name: 'Minimax - Adulta Sábia',
    voiceURI: 'Portuguese_Wiselady',
    volume: 1,
    pitch: 0,
    emotion: MinimaxSpeechEmotions.AUTO,
    rate: 1, // speed na minimax
  },
];

